
import { Component, Vue } from "vue-property-decorator";
import SeeksRelationGraph from "relation-graph";
import Template from "@/views/system-management/template/index.vue";
import { queryDocuments, shipmentPosition,getDocumentsStreamV2 } from "@/api/document-flow";
import { getDeliveryNoteStateList } from "@/api/delivery-note";
import { getHqPackingListStates } from "@/api/hq-packing-list";
import { getFactoryLoadingPlanStates } from "@/api/factory-loading-plans";
import { getHenganLoadingPlanStates } from "@/api/hengan-loading-plan";
import { getShippingOrderStatus } from "@/api/shipping-order";
import { listProcessStages } from "@/api/booking-order";
import TopologyMap from "./TopologyMap.vue"
import { getClearingStatus } from "@/api/invoice"
import { getRAAllStates } from "@/api/remittance-advices"
import { getOrderStatus } from "@/api/purchase-order"
import { getInquiryStatus } from "@/api/inquiry"
import { getStatus } from "@/api/supplier-payment"
import { getPiDeliveryStatus } from "@/api/proforma"
import { getCNState } from "@/api/credit-note"
import {getToken} from "@/utils/cookies";

@Component({
  name: "DocumentFlow",
  components: { Template, SeeksRelationGraph,TopologyMap },
})
export default class extends Vue {
  private showDialog = false;
  private g_loading = true;
  private type = "";
  private documentId = "";
  private action = "定位";
  private breviary = false;
  private demoname = "------";
  private currentCase = "缩略视图";
  private graphOptions = {
    backgrounImageNoRepeat: true,
    defaultFocusRootNode: false,
    disableNodeClickEffect: true,
    disableLineClickEffect: true,
    moveToCenterWhenRefresh: true,
    layouts: [
      {
        label: "树",
        layoutName: "tree",
        layoutClassName: "seeks-layout-center",
        defaultNodeShape: 0,
        from: "left",
        // 通过这4个属性来调整 tree-层级距离&节点距离
        max_per_width: "400",
        min_per_width: "400",
        min_per_height: "400",
        max_per_height: "600",
      },
    ],
    defaultLineMarker: {
      markerWidth: 12,
      markerHeight: 12,
      refX: 6,
      refY: 6,
      data: "M2,2 L10,6 L2,10 L6,6 L2,2",
    },
    defaultNodeShape: 1,
    // defaultNodeWidth: '100',
    defaultLineShape: 4,
    defaultJunctionPoint: "lr",
    defaultNodeBorderWidth: 0,
    defaultLineColor: "rgb(0,0,0)",
    defaultNodeColor: "rgb(255,255,255)",
  };
  private data: FollowData = new FollowData();

  private stringLB = {
    state: '状态',
    company: '公司名称',
    createAt: '创建时间',
    deposit: '是否有定金',
    paymentMethod: '支付方式',
    factoryName: '工厂名称',
    hqPackingListType: '装箱单类型',
    auditState: '验审状态',
    storageLayerNames: '仓库名称',
    deliveryNoteWarehousingInState: '进仓状态',
    deliveryNoteWarehousingOutState: '出仓状态',
    factoryLoadingPlanStateTime: '报关计划时间',
    transshipInfo: '是否驳货',
    allocationState: '分配状态',
    shippingOrderCode: '订舱单号',
    stage: '报关阶段',
    collectInvoiceDate: '开票时间',
    checkPrerecordListDate: '验审时间',
    issuedDate: '开票日期',
    receiptOfAmountDate: '收款时间',
    paymentTime: '付款时间',
    declarationState: '清账状态',
    declarationTime: '清账时间'
  }

  private dataKey = []as any;

  private socket;

  private perList = {
    arr: []
  }

  created() {
    this.type = this.$route.params.type;
    this.documentId = this.$route.params.documentId;
    this.getList();
  }

  beforeDestroy() {
    this.socket.close()
  }

  private getLimitsAuthority() {
    this.getSocket(`ws://${location.host}/${process.env.VUE_APP_BASE_API}/hq-lms/ws`, [], `token=${getToken()}`, (message, ws) => {
      if (message.data) {
        this.$set(this.perList,'arr', message.data)
      }
    });
  }

  private getSocket(url, Authorization, params, callback) {
    if (typeof WebSocket === "undefined") {
      console.log('您的浏览器暂时不支持WebSocket！')
    } else {
      this.socket = new WebSocket(url, Authorization);
      this.socket.onopen = () => {
        console.log("WebSocket 已打开");
        this.socket.send(params);
      };
      this.socket.onmessage = (msg) => {
        callback(msg, this.socket);
      };

      this.socket.onclose = () => {
        console.log("WebSocket 已关闭");
      };

      this.socket.onerror = (err) => {
        console.log("Socket 发生了错误,请刷新页面", err); // 此时可以尝试刷新页面
      };
    }
  }


  private showBreviary() {
    this.breviary = !this.breviary;
    this.getList();
  }

  private stateListFirst: [{ name: string; desc: string }] = [
    { name: null, desc: null },
  ];
  private stateListSecond: [{ name: string; desc: string }] = [
    { name: null, desc: null },
  ];
  private nowState = "";
  private nowStated = "";

  private async getList(BtnForData = null) {
    let params = {
      documentsId:this.documentId,type:this.type,action:this.action,expand:this.breviary
    }
    const data_: Follow[] = (await getDocumentsStreamV2(params)) as any;
    if(data_.length > 0) {
      this.dataKey = Object.keys(data_[0])
      let deleteArr = ['id','type','pids','code','typeCode','route']
      deleteArr.map(es => {
        if(this.dataKey.findIndex(ex => ex === es) !== -1) {
          this.dataKey.splice(this.dataKey.findIndex(ex => ex === es),1)
        }
      })
    }
    // const treeRoot = data_[0] as any;
    this.stateListFirst = null;
    this.stateListSecond = null;
    if(BtnForData) {
      const treeRoot = BtnForData;
      switch (this.type) {
        case "HQ_PACKING_LIST": // 装箱单详情
          this.nowState = treeRoot.state;
          this.stateListFirst = (await getHqPackingListStates()) as any;
          break;
        case "DELIVERY_NOTE": // 装箱单管理
          this.nowState = treeRoot.deliveryNoteWarehousingInState
          this.nowStated = treeRoot.deliveryNoteWarehousingOutState
          await this.initDeliveryNoteStateList();
          break;
        case "FACTORY_LOADING_PLAN": // 报关计划
          this.nowState = treeRoot.state;
          this.stateListFirst = (await getFactoryLoadingPlanStates()) as any;
          break;
        case "HENG_AN_LOADING_PLAN": // 出库计划
          this.nowState = treeRoot.state;
          this.stateListFirst = (await getHenganLoadingPlanStates()) as any;
          break;
        case "SHIPPING_ORDER": // 订舱单
          this.nowState = treeRoot.state;
          const { status }: any = await getShippingOrderStatus();
          this.stateListFirst = status;
          break;
        case "BOOKING_ORDER": // 报关合同
          this.nowState = treeRoot.stage;
          this.stateListFirst = (await listProcessStages()) as any;
          break;
        case "FACTORY_INVOICE": // 工厂开票
          this.nowState = treeRoot.stage;
          break;
        case "IV": // IV
          this.nowState = treeRoot.stage;
          this.stateListFirst = (await getClearingStatus()) as any;
          break;
        case "REMITTANCE_ADVICE": // 收汇单
          this.nowState = treeRoot.stage;
          this.stateListFirst = (await getRAAllStates()) as any;
          break;
        case "PURCHASE_ORDER": // 采购订单
          this.nowState = treeRoot.stage;
          this.stateListFirst = (await getOrderStatus()) as any;
          break;
        case "INQUIRY_SHEET": // 询价单
          this.nowState = treeRoot.stage;
          this.stateListFirst = (await getInquiryStatus()) as any;
          break;
        case "PAYMENT_VOUCHER": // 付款单
          this.nowState = treeRoot.stage;
          this.stateListFirst = (await getStatus()) as any;
          break;
        case "PI": // PI-销售订单
          this.nowState = treeRoot.stage;
          this.stateListFirst = (await getPiDeliveryStatus()) as any;
          break;
        case "CREDIT_NOTICE": // CN
          this.nowState = treeRoot.stage;
          this.stateListFirst = (await getCNState()) as any;
          break;
        default:
          break;
      }
    } else {
      const treeRoot = data_[0] as any;
      switch (this.type) {
        case "HQ_PACKING_LIST": // 装箱单详情
          this.nowState = treeRoot.state;
          this.stateListFirst = (await getHqPackingListStates()) as any;
          break;
        case "DELIVERY_NOTE": // 装箱单管理
          this.nowState = treeRoot.deliveryNoteWarehousingInState
          this.nowStated = treeRoot.deliveryNoteWarehousingOutState
          await this.initDeliveryNoteStateList();
          break;
        case "FACTORY_LOADING_PLAN": // 报关计划
          this.nowState = treeRoot.state;
          this.stateListFirst = (await getFactoryLoadingPlanStates()) as any;
          break;
        case "HENG_AN_LOADING_PLAN": // 出库计划
          this.nowState = treeRoot.state;
          this.stateListFirst = (await getHenganLoadingPlanStates()) as any;
          break;
        case "SHIPPING_ORDER": // 订舱单
          this.nowState = treeRoot.state;
          const { status }: any = await getShippingOrderStatus();
          this.stateListFirst = status;
          break;
        case "BOOKING_ORDER": // 报关合同
          this.nowState = treeRoot.stage;
          this.stateListFirst = (await listProcessStages()) as any;
          break;
        case "FACTORY_INVOICE": // 工厂开票
          this.nowState = treeRoot.stage;
          break;
        case "IV": // IV
          this.nowState = treeRoot.stage;
          this.stateListFirst = (await getClearingStatus()) as any;
          break;
        case "REMITTANCE_ADVICE": // 收汇单
          this.nowState = treeRoot.stage;
          this.stateListFirst = (await getRAAllStates()) as any;
          break;
        case "PURCHASE_ORDER": // 采购订单
          this.nowState = treeRoot.stage;
          this.stateListFirst = (await getOrderStatus()) as any;
          break;
        case "INQUIRY_SHEET": // 询价单
          this.nowState = treeRoot.stage;
          this.stateListFirst = (await getInquiryStatus()) as any;
          break;
        case "PAYMENT_VOUCHER": // 付款单
          this.nowState = treeRoot.stage;
          this.stateListFirst = (await getStatus()) as any;
          break;
        case "PI": // PI-销售订单
          this.nowState = treeRoot.stage;
          this.stateListFirst = (await getPiDeliveryStatus()) as any;
          break;
        case "CREDIT_NOTICE": // CN
          this.nowState = treeRoot.stage;
          this.stateListFirst = (await getCNState()) as any;
          break;
        default:
          break;
      }
    }
    this.refreshList(data_);
  }

  private refreshList(data_: any) {
    this.data.nodes = this.buildData(data_);
    this.data.rootId = this.documentId;
    this.data.links = this.buildLinks(data_);
    this.demoname = this.$route.params.demoname;
    this.setGraphData();
  }

  private getDocumentFlow(node,item) {
    this.documentId = node.data.id;
    this.action = item
    this.type = node.data.typeCode;
    this.getList(node.data);
  }

  private async shipmentPosition(value) {
    const data_: Follow[] = (await shipmentPosition(value.data.id)) as any;
    this.refreshList(data_);
  }

  private buildData(values: Follow[]) {
    return values.map((v) => new NodeData(v.id, v.code, v));
  }

  private buildLinks(values: Follow[]) {
    let data: LinksData[] = [];
    for (let i = 0; i < values.length; i++) {
      for (let j = 0; j < values.length; j++) {
        if (values[j].pids && values[j].pids.indexOf(values[i].id) > -1) {
          if (values[j].pids && values[j].pids.indexOf(values[j].id) > -1) {
            this.data.rootId = values[j].id;
            continue;
          }
          data.push(new LinksData(values[i].id, values[j].id));
        }
      }
    }
    return data;
  }

  private compBtnArr(data,type) {
    let reStr = []
    switch (type) {
      case "PI":
        reStr = ['收款定位','发货定位']
        break;
      case "pi":
        reStr = ['收款定位','发货定位']
        break;
      case "采购订单":
        reStr = ['交货定位','付款定位','订单定位']
        break;
      case "装箱单":
        if(data.hqPackingListType && data.hqPackingListType === '报关计划') {
          reStr = ['付款定位','发货定位']
        } else {
          reStr = ['付款定位','发货定位','进仓单定位']
        }
        break;
      case "工厂结算":
        reStr = ['发货定位','订单定位']
        break;
      case "IV":
        reStr = ['CN定位']
        break;
      default:
        break;
    }
    reStr.push('定位')
    return reStr
  }

  private gotoRouter(value) {
    if(!value.data.route) {
      this.$notify({
        title: '提示',
        message: '您没有该单据的权限，请联系管理员！',
        type: 'warning'
      })
      return
    }
    const input = document.createElement("input");
    document.body.appendChild(input);
    input.setAttribute("value", value.text);
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);

    switch (value.data.typeCode) {
      // 装箱单详情
      case "HQ_PACKING_LIST":
        this.$router.push({
          name: "HqPackingListDetail",
          params: {
            type: value.data.hqPackingListType === "报关计划" ? "FACTORY_LOADING_PLAN" : "DELIVERY_NOTE",
            parentId: "1",
            hqPackingListId: value.data.id
          },
        });
        break;
      // 装箱单管理
      case "DELIVERY_NOTE":
        this.$router.push({
          name: "DeliveryPackingList",
          params: {
            type: "delivery-note",
            parentId: value.data.id,
          },
        });
        break;
      // 报关计划
      case "FACTORY_LOADING_PLAN":
        this.$router.push({
          name: "PackingList",
          params: {
            type: "factory-loading-plan",
            parentId: value.data.id,
          },
        });
        break;
      //出库计划
      case "HENG_AN_LOADING_PLAN":
        this.$router.push({
          name: "HenganLoadingPlanDetailForWarehouse",
          params: {
            henganLoadingPlanId: value.data.id,
          },
        });
        break;
      // 订舱单
      case "SHIPPING_ORDER":
        this.$router.push({
          path: "/shipping-management",
          query: {
            code: value.data.code
          },
        });
        break;
      // 报关合同
      case "BOOKING_ORDER":
        this.$router.push({
          path: "/bookingOrderManagement",
          query: {
            code: value.data.code
          },
        });
        break;
      // 工厂开票
      case "FACTORY_INVOICE": // 暂时先不做跳转加参数
        this.$router.push({
          name: "FactoryInvoiceManagement",
          params: {},
        });
        break;
      case "IV":
        this.$router.push({
          path: '/customer-iv-managementInfo',
          query: { // 需要IV号码
            code: value.data.code,
            // customerId: value.data.id
            customerId: ''
          }
        });
        break;
        // 收汇单
      case "REMITTANCE_ADVICE":
      this.$router.push({
          path: '/collectionManagement',
          query: { // 需要收汇单号
            code: value.data.code,
          }
        });
        break;
        // 采购订单
      case "PURCHASE_ORDER":
      this.$router.push({
          path: '/purchaseOrderDetails',
          query: {
            id: value.data.id,
            supplierId: value.data.supplierId || '',
          }
        });
        break;
        // 询价单
      case "INQUIRY_SHEET":
      this.$router.push({
          path: '/askingForQuotationManagement',
          query: {
            code: value.data.code,
          }
        });
        break;
        // 付款单
      case "PAYMENT_VOUCHER":
      this.$router.push({
          path: '/paymentOrderDetails',
          query: {
            id: value.data.id,
          }
        });
        break;
        // pi 销售订单
      case "PI":
      this.$router.push({
          path: '/PIDetails',
          query: {
            id: value.data.id,
          }
        });
        break;
      case "CREDIT_NOTICE":
      this.$router.push({
          path: '/creditNoteManagement',
          query: {
            code: value.data.code,
          }
        });
        break;
    }
  }

  private async initDeliveryNoteStateList() {
    const { out, inStates }: any = await getDeliveryNoteStateList();
    this.stateListFirst = inStates;
    this.stateListSecond = out;
  }

  private setGraphData() {
    // 使用要点：通过节点属性expandHolderPosition: 'right' 和 expanded: false 可以让节点在没有子节点的情况下展示一个"展开"按钮
    //         通过onNodeExpand事件监听节点，在被展开的时候有选择的去从后台获取数据，如果已经从后台加载过数据，则让当前图谱根据当前的节点重新布局
    this.g_loading = false;
    const seeksRelationGraph: any = this.$refs.seeksRelationGraph;
    seeksRelationGraph.setJsonData(this.data, (seeksRGGraph) => {
      // 这些写上当图谱初始化完成后需要执行的代码
    });
  }
}

class FollowData {
  rootId: string;
  nodes: NodeData[];
  links: LinksData[];
}

class NodeData {
  id: string;
  text: string;
  data: Follow;
  width: number;
  height: number;

  constructor(id: string, text: string, data: Follow) {
    this.id = id;
    this.text = text;
    this.data = data;
    // this.width = 250;
    // this.height = 300;
  }
}

class LinksData {
  from: string;
  to: string;

  constructor(from: string, to: string) {
    this.from = from;
    this.to = to;
  }
}

class Follow {
  type: string;
  id: string;
  pids: string[];
  code: string;
  state: string;
  createAt: string;
  // 进仓单
  storageLayerNames: string;
  deliveryNoteWarehousingInState: string;
  deliveryNoteWarehousingOutState: string;
  // 装箱单
  factoryName: string;
  parentType: string;
  parentId: string;
  auditState: string;
  // 出库计划
  transshipInfo: string;
  // 订舱单
  shippingSpaceState: string;
  allocationState: string;
  //报关合同
  shippingOrderCode: string;
  stage: string;
  declarationTime;
  //工厂开票
  collectInvoiceDate: string;
  checkPrerecordListDate: string;
}
